<template>
  <modal
    v-slot="{ data }"
    name="challengeDetails"
    modal-style="compact"
  >
    <challenge-details :data="data" />
  </modal>
</template>

<script>
  import ChallengeDetails from './challenge-details/index.vue';

  export default {
    name: 'ChallengeDetailsModal',

    components: {
      ChallengeDetails
    }
  };
</script>
